import { render, staticRenderFns } from "./TestatUpload.vue?vue&type=template&id=eea5d218&scoped=true"
import script from "./TestatUpload.vue?vue&type=script&lang=ts"
export * from "./TestatUpload.vue?vue&type=script&lang=ts"
import style0 from "./TestatUpload.vue?vue&type=style&index=0&id=eea5d218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eea5d218",
  null
  
)

export default component.exports